/** Services Vinz can reserve. cellarium joins when cellarium#1542 (its CDK migration) merges. */
export type DeployPath = 'ecs' | 'serverless' | 'cdk';

export interface Reservable {
  /** Repository name under the rewindio org. */
  repo: string;
  /** The deploy workflow file Vinz dispatches on release. */
  workflow: string;
  path: DeployPath;
}

const ecs = (repo: string, workflow = 'deployment-ecs.yml'): Reservable => ({ repo, workflow, path: 'ecs' });
const cdk = (repo: string): Reservable => ({ repo, workflow: 'cdk-deploy.yml', path: 'cdk' });

export const RESERVABLE: readonly Reservable[] = [
  ecs('ultron'), ecs('restore-service'), ecs('argus'), ecs('nimbus'), ecs('charon'),
  ecs('galactus', 'deployment.yml'),
  { repo: 'dewey', workflow: 'deploy.yml', path: 'serverless' },
  cdk('galactus-lambda'), cdk('atlas'), cdk('external-user-service'), cdk('lazarus-api'),
  cdk('atlas_sns_lambda_forwarder'), cdk('engine-purge-sns-lambda-forwarder'),
];

export function reservable(repo: string): Reservable | undefined {
  return RESERVABLE.find((r) => r.repo === repo);
}
